<div class="move-transfer-container">
  <!-- ローディング -->
  <div *ngIf="isLoading" class="loading-message">データを読み込んでいます...</div>

  <!-- エラーメッセージ -->
  <div *ngIf="errorMessage && !isLoading" class="error-message">{{ errorMessage }}</div>

  <!-- 転記処理コンテンツ -->
  <div class="move-transfer-content">
    
    <!-- ブロック1: 削除データと転記先の検索 -->
    <div class="block block-search">
      <div class="block-title">削除データと転記先の検索</div>
      
      <div class="search-container">
        <!-- 左側: 削除データの検索 -->
        <div class="search-section search-left">
          <h4 class="search-subtitle">削除データの検索：</h4>
          <div class="search-inputs">
            <div class="input-row">
              <label>申請番号</label>
              <input type="text" [(ngModel)]="searchRequestId" placeholder="例: R12" autocomplete="off">
            </div>
            <div class="input-row">
              <label>アラート番号</label>
              <input type="text" [(ngModel)]="searchOdchgId" placeholder="例: A151" autocomplete="off">
            </div>
            <div class="input-row">
              <label>獲注番号</label>
              <input 
                type="text" 
                [(ngModel)]="searchSourceJobOrderId" 
                maxlength="9"
                pattern="[0-9]*"
                placeholder="例: 123456789"
                autocomplete="off">
            </div>
            <button class="btn-display" (click)="loadSourceDataBySearch()">表示</button>
          </div>
        </div>

        <!-- 右側: 転記先の検索 -->
        <div class="search-section search-right">
          <h4 class="search-subtitle">転記先の検索：</h4>
          <div class="search-inputs">
            <div class="input-row">
              <label>獲注番号</label>
              <input 
                type="text" 
                [(ngModel)]="inputJobOrderId"
                maxlength="9"
                pattern="[0-9]*"
                placeholder="例: 123456789"
                autocomplete="off">
            </div>
            <button class="btn-display" (click)="loadDestinationTimesheetByInput()">表示</button>
          </div>
        </div>
      </div>
    </div>

    <!-- ブロック1B: 転記候補 -->
    <div class="block block-1b" *ngIf="moveTransferData?.destinations && moveTransferData.destinations.length > 0">
      <div class="block-title">転記候補</div>

      <!-- 転記先リンク一覧 -->
      <div class="destinations-list">
        <div *ngFor="let dest of moveTransferData.destinations" class="destination-item">
          <a (click)="loadDestinationTimesheetByLink(dest?.jobOrderID)" class="destination-link">
            {{ dest?.resultText }}
          </a>
        </div>
      </div>
    </div>

    <div class="block block-1b" *ngIf="!moveTransferData?.destinations">
      <div class="info-message">
        転記先データが読み込まれていません。
      </div>
    </div>

    <!-- ブロック2とブロック3を横並びに配置 -->
    <div class="blocks-row">
      <!-- ブロック2: 転記元タイムシート -->
      <div class="block block-2">
        <div class="block-title">
          <span>転記元タイムシート（削除分）</span>
          <span class="state-filters">
            <label class="filter-checkbox">
              <input type="checkbox" [(ngModel)]="filterHold" (change)="onStateFilterChange()"> 保
            </label>
            <label class="filter-checkbox">
              <input type="checkbox" [(ngModel)]="filterReported" (change)="onStateFilterChange()"> 報
            </label>
            <label class="filter-checkbox">
              <input type="checkbox" [(ngModel)]="filterDenied" (change)="onStateFilterChange()"> 否
            </label>
            <label class="filter-checkbox">
              <input type="checkbox" [(ngModel)]="filterReported2" (change)="onStateFilterChange()"> 認
            </label>
          </span>
        </div>
      
        <!-- 契約内容表 -->
        <div class="contract-table-wrapper" *ngIf="moveTransferData?.summary && moveTransferData?.sourceData">
          <table class="contract-table">
            <tr>
              <th>期間</th>
              <td>{{ moveTransferData?.summary?.originalPeriod }}</td>
              <th>獲注番号</th>
              <td>
                <a (click)="openJobOrderInfo(moveTransferData?.summary?.jobOrderID)" 
                   style="color: #007bff; text-decoration: underline; cursor: pointer;">
                  {{ moveTransferData?.summary?.jobOrderID }}
                </a>
              </td>
              <th>顧客部署コード</th>
              <td>
                <a (click)="openCustomerInfo(moveTransferData?.sourceData?.customerOfficeID)" 
                   style="color: #007bff; text-decoration: underline; cursor: pointer;">
                  {{ moveTransferData?.sourceData?.customerOfficeCode }}
                </a>
              </td>
            </tr>
          </table>
        </div>

        <!-- TimesheetLineItem テーブル -->
        <div class="custom-table-wrapper" *ngIf="filteredSourceLineItems && filteredSourceLineItems.length > 0">
          <table class="custom-timesheet-table">
            <thead>
              <tr>
                <th class="checkbox-col center-align">
                  <input type="checkbox" 
                         [checked]="selectAllLineItems"
                         (change)="toggleSelectAllLineItems()">
                </th>
                <th class="col-state center-align">状態</th>
                <th class="col-date center-align">日</th>
                <th class="col-time right-align">開始</th>
                <th class="col-time right-align">終了</th>
                <th class="col-minutes right-align">休憩</th>
                <th class="col-minutes right-align">深休</th>
                <th class="col-telework center-align">在宅</th>
                <th class="col-lineitem left-align">届出</th>
                <th class="col-costitem left-align">交通費等</th>
                <th class="col-cost right-align">金額</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of filteredSourceLineItems">
                <td class="checkbox-col center-align">
                  <input type="checkbox" 
                         [checked]="isLineItemSelected(item.timesheetLineItemID)"
                         (change)="toggleLineItem(item.timesheetLineItemID)">
                </td>
                <td class="col-state center-align">{{ item.state }}</td>
                <td class="col-date right-align">{{ item.dayDate }}</td>
                <td class="col-time right-align">{{ formatTime(item.startTime) }}</td>
                <td class="col-time right-align">{{ formatTime(item.endTime) }}</td>
                <td class="col-minutes right-align">{{ (formatTime(item.startTime) === '' && formatTime(item.endTime) === '') ? '' : item.breakMinutes }}</td>
                <td class="col-minutes right-align">{{ (formatTime(item.startTime) === '' && formatTime(item.endTime) === '') ? '' : item.midnightBreakMinutes }}</td>
                <td class="col-telework center-align">{{ item.teleWork }}</td>
                <td class="col-lineitem left-align">{{ item.lineItem }}</td>
                <td class="col-costitem left-align">{{ item.costItem }}</td>
                <td class="col-cost right-align">{{ (formatTime(item.startTime) === '' && formatTime(item.endTime) === '' && !item.cost) ? '' : item.cost }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        
        <!-- データがない場合のメッセージ -->
        <div *ngIf="!filteredSourceLineItems || filteredSourceLineItems.length === 0" class="info-message">
          転記元タイムシートデータがありません。
        </div>

        <!-- Timesheet コメントテーブル -->
        <div class="custom-table-wrapper" *ngIf="moveTransferData?.sourceData">
          <table class="custom-comments-table">
            <thead>
              <tr>
                <th class="checkbox-col">選択</th>
                <th class="col-comment-timesheet-id">TimesheetID</th>
                <th class="col-comment-weekending">対象月</th>
                <th class="col-comment">コメント</th>
                <th class="col-training">訓練記録</th>
                <th class="col-complaint">苦情処理記録</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="!moveTransferData?.sourceData?.comments || moveTransferData?.sourceData?.comments?.length === 0">
                <td colspan="6" style="text-align: center; color: #999;">コメントデータがありません</td>
              </tr>
              <tr *ngFor="let comment of moveTransferData?.sourceData?.comments">
                <td class="checkbox-col">
                  <input type="checkbox" 
                         [checked]="isCommentTimesheetSelected(comment.timesheetID)"
                         (change)="toggleCommentTimesheet(comment.timesheetID)">
                </td>
                <td class="col-comment-timesheet-id right-align">{{ comment.timesheetID }}</td>
                <td class="col-comment-weekending center-align">{{ formatWeekEndingToYearMonth(comment.weekEnding) }}</td>
                <td class="col-comment">{{ comment.comments }}</td>
                <td class="col-training">{{ comment.trainingComments }}</td>
                <td class="col-complaint">{{ comment.complaintComments }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- 転記するボタンと処理を確定するボタン（右寄せ） -->
        <div class="complete-button-row" *ngIf="moveTransferData?.sourceData">
          <button class="btn-move" (click)="moveToDestination()"
                  [disabled]="!destinationTimesheetData || !destinationTimesheetData.jobOrderID || (selectedLineItems.size === 0 && selectedCommentTimesheetIds.size === 0)">
            転記する
          </button>
          <button class="btn-confirm-process" (click)="confirmProcessing()"
                  *ngIf="actualRequestId || actualOdchgId"
                  style="margin-left: 10px;">
            処理を確定する
          </button>
        </div>
      </div>

      <!-- ブロック3: 転記先タイムシート -->
      <div class="block block-3">
        <div class="block-title">転記先タイムシート</div>

        <!-- 転記先データが取得されている場合に表示 -->
        <div *ngIf="destinationTimesheetData" class="destination-content">
          <!-- 契約内容表 -->
          <div class="contract-table-wrapper" *ngIf="moveTransferData?.summary">
            <table class="contract-table">
              <tr>
                <th>期間</th>
                <td>{{ moveTransferData?.summary?.newPeriod }}</td>
                <th>獲注番号</th>
                <td>
                  <a (click)="openJobOrderInfo(destinationTimesheetData?.jobOrderID)" 
                     style="color: #007bff; text-decoration: underline; cursor: pointer;">
                    {{ destinationTimesheetData?.jobOrderID }}
                  </a>
                </td>
                <th>顧客部署コード</th>
                <td>
                  <a (click)="openCustomerInfo(destinationTimesheetData?.customerOfficeID)" 
                     style="color: #007bff; text-decoration: underline; cursor: pointer;">
                    {{ destinationTimesheetData?.customerOfficeCode }}
                  </a>
                </td>
              </tr>
            </table>
          </div>

          <!-- TimesheetLineItem テーブル -->
          <div class="custom-table-wrapper">
            <table class="custom-timesheet-table">
              <thead>
                <tr>
                  <th class="col-state center-align">状態</th>
                  <th class="col-date center-align">日</th>
                  <th class="col-time right-align">開始</th>
                  <th class="col-time right-align">終了</th>
                  <th class="col-minutes right-align">休憩</th>
                  <th class="col-minutes right-align">深休</th>
                  <th class="col-telework center-align">在宅</th>
                  <th class="col-lineitem left-align">届出</th>
                  <th class="col-costitem left-align">交通費等</th>
                  <th class="col-cost right-align">金額</th>
                  <th class="col-timesheet-id center-align">TimesheetID</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of destinationTimesheetData.lineItems">
                  <td class="col-state center-align">{{ item.state }}</td>
                  <td class="col-date right-align">{{ item.dayDate }}</td>
                  <td class="col-time right-align">{{ formatTime(item.startTime) }}</td>
                  <td class="col-time right-align">{{ formatTime(item.endTime) }}</td>
                  <td class="col-minutes right-align">{{ (formatTime(item.startTime) === '' && formatTime(item.endTime) === '') ? '' : item.breakMinutes }}</td>
                  <td class="col-minutes right-align">{{ (formatTime(item.startTime) === '' && formatTime(item.endTime) === '') ? '' : item.midnightBreakMinutes }}</td>
                  <td class="col-telework center-align">{{ item.teleWork }}</td>
                  <td class="col-lineitem left-align">{{ item.lineItem }}</td>
                  <td class="col-costitem left-align">{{ item.costItem }}</td>
                  <td class="col-cost right-align">{{ (formatTime(item.startTime) === '' && formatTime(item.endTime) === '' && !item.cost) ? '' : item.cost }}</td>
                  <td class="col-timesheet-id center-align">
                    <a (click)="onTimesheetClick(item.timesheetID)" class="link-text">
                      {{ item.timesheetID }}
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Timesheet コメントテーブル -->
          <div class="table-section" *ngIf="destinationTimesheetData.comments && destinationTimesheetData.comments.length > 0">
            <table class="custom-comments-table">
              <thead>
                <tr>
                  <th class="col-comment-timesheet-id">TimesheetID</th>
                  <th class="col-comment-weekending">対象月</th>
                  <th class="col-comment">コメント</th>
                  <th class="col-training">訓練記録</th>
                  <th class="col-complaint">苦情処理記録</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let comment of destinationTimesheetData.comments">
                  <td class="col-comment-timesheet-id right-align">{{ comment.timesheetID }}</td>
                  <td class="col-comment-weekending center-align">{{ formatWeekEndingToYearMonth(comment.weekEnding) }}</td>
                  <td class="col-comment">{{ comment.comments }}</td>
                  <td class="col-training">{{ comment.trainingComments }}</td>
                  <td class="col-complaint">{{ comment.complaintComments }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- データが未取得の場合 -->
        <div *ngIf="!destinationTimesheetData" class="no-data-message">
          <p>転記候補ブロックから転記先を選択してください。</p>
        </div>
      </div>
    </div>

  </div>
</div>
